import { useState, useEffect } from "react";
import { Link } from "react-router"; // Make sure to import from 'react-router'
import MallabhumPrayas from "../MallabhumPrayas";

const menuItems = [
  { name: "Home", path: "/home" },
  {
    name: "About",
    subItems: [
      { name: "Team", path: "/team" },
      { name: "Testimonials", path: "/testimonials" },
    ],
  },
  {
    name: "Our Initiatives",
    subItems: [
      { name: "Zero wastage food", path: "/zero-wastage-food" },
      { name: "Bina payasar bazar", path: "/bina-paysar-bazar" },
      { name: "Free Napkin Service", path: "/free-napkin" },
      {
        name: "Education Help",
        path: "/education-help",
        // subItems: [
        //   { name: "Prativa", path: "/prativa" },
        //   { name: "Vidyachaya", path: "/vidyachaya" },
        // ],
      },
      {
        name: "Khusi Ferao Event",
        path: "/khushi-ferao",
        // subItems: [
        //   { name: "Nutritious Food", path: "/nutritious-food" },
        //   { name: "New Cloth", path: "/new-cloth" },
        //   { name: "Winter Cloth", path: "/winter-cloth" },
        //   { name: "Necessity Item", path: "/necessity-item" },
        //   { name: "Cultural Event", path: "/Cultural-event" },
        //   { name: "Child's Game Event", path: "/child-game-event" },
        //   { name: "Janata Dokan(Dry Nutritious food)", path: "/janata-dokan" },
        // ],
      },
      {
        name: "Medical Help",
        path: "/medical-help",
        // subItems: [
        //   { name: "Oxygen Service", path: "/medical-help" },
        //   { name: "Ambulance Service", path: "/ambulance-service" },
        //   { name: "Medical Camp", path: "/medical-camp" },
        //   {
        //     name: "Medical Necessary Item Help",
        //     path: "/medical-necessary-item-help",
        //   },
        // ],
      },
      {
        name: "Direct Blood Donate",
        path: "/dbd",
        // subItems: [
        //   { name: "DBD", path: "/dbd" },
        //   { name: "Camp", path: "/camp" },
        //   {
        //     name: "Card",
        //     path: "/card",
        //   },
        // ],
      },
      {
        name: "Nature Bachao Event",
        path: "/nature-bachao",
        // subItems: [
        //   { name: "Plantation", path: "/plantation" },
        //   { name: "Save Water", path: "/save-water" },
        //   { name: "Save animal", path: "/save-animal" },
        //   {
        //     name: "Save Bird",
        //     path: "/save-bird",
        //   },
        //   {
        //     name: "Swachhata Abhiyan",
        //     path: "/swachhata-abhiyan",
        //   },
        // ],
      },
      {
        name: "COVID 19 Service",
        path: "/covid-service",
        // subItems: [
        //   { name: "Janata Kitchen", path: "/janata-kitchen" },
        //   { name: "Janta Dokan", path: "/janta-dokan" },
        //   { name: "COVID-AWARENESS", path: "/covid-awareness" },
        //   {
        //     name: "Oxygen Service",
        //     path: "/oxygen-service",
        //   },
        //   {
        //     name: "Ambulance Service",
        //     path: "/ambulance-service",
        //   },
        // ],
      },
      // { name: "Awareness Event", path: "/awareness-event" },
      // { name: "Rescue Operation", path: "/rescue-operation" },
      // { name: "Orientation Event", path: "/orientation-event" },
    ],
  },
  {
    name: " Our Publications",
    subItems: [
      { name: "Darpan", path: "/darpan" },
      { name: "Media Coverage", path: "/media-coverage" },
    ],
  },
  { name: "Recent Activity", path: "/recent-activity" },
  { name: "Contact", path: "/contact" },
];

function Header() {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // State to track active dropdown
  const [activeSubDropdown, setActiveSubDropdown] = useState(null); // State to track active sub-dropdown

  useEffect(() => {
    if (isMobileNavActive) {
      document.body.classList.add("index-page", "mobile-nav-active");
    } else {
      document.body.classList.remove("index-page", "mobile-nav-active");
    }
    return () => {
      document.body.classList.remove("index-page", "mobile-nav-active");
    };
  }, [isMobileNavActive]);

  const toggleMobileNav = () => {
    setIsMobileNavActive((prev) => !prev);
  };

  const handleDropdownToggle = (index) => {
    setActiveDropdown((prev) => (prev === index ? null : index)); // Toggle active dropdown
    setActiveSubDropdown(null); // Reset sub-dropdown when toggling main dropdown
  };

  const handleSubDropdownToggle = (index) => {
    setActiveSubDropdown((prev) => (prev === index ? null : index)); // Toggle active sub-dropdown
  };

  const renderMenuItems = (items) => {
    return items.map((item, index) => {
      if (item.subItems) {
        return (
          <li className="dropdown" key={index}>
            <Link to={item.path} onClick={() => handleDropdownToggle(index)}>
              <span>{item.name}</span>{" "}
              <i className="bi bi-chevron-down toggle-dropdown" />
            </Link>
            <ul
              className={`dropdown-${activeDropdown === index ? "active" : ""}`}
            >
              {item.subItems.map((subItem, subIndex) => {
                if (subItem.subItems) {
                  return (
                    <li className="dropdown" key={subIndex}>
                      <Link
                        to={subItem.path}
                        onClick={() => handleSubDropdownToggle(subIndex)}
                      >
                        <span>{subItem.name}</span>{" "}
                        <i className="bi bi-chevron-down toggle-dropdown" />
                      </Link>
                      <ul
                        className={`dropdown-${
                          activeSubDropdown === subIndex ? "active" : ""
                        }`}
                      >
                        {renderMenuItems(subItem.subItems)}
                      </ul>
                    </li>
                  );
                }
                return (
                  <li key={subIndex}>
                    <Link to={subItem.path}>{subItem.name}</Link>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      }
      return (
        <li key={index}>
          <Link to={item.path}>{item.name}</Link>
        </li>
      );
    });
  };

  return (
    <header id="header" className="header d-flex align-items-center sticky-top">
      <div className="container position-relative d-flex align-items-center">
        <span
          href="index.html"
          className="logo d-flex align-items-center me-auto"
        >
          <img src="/assets/img/mlogo/mlogo.png" alt="Mallabhum Prayas" />
          <span>
            <MallabhumPrayas />
          </span>
        </span>
        <nav id="navmenu" className="navmenu">
          <ul>{renderMenuItems(menuItems)}</ul>
          <i
            className="mobile-nav-toggle d-xl-none bi bi-list"
            onClick={toggleMobileNav}
          />
        </nav>
        <div className="header-social-links">
          <a href="https://www.facebook.com/mallabhum.prayas/" className="facebook" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-facebook" />
          </a>
          <a href="https://www.instagram.com/mallabhum_prayas/?igsh=MTFvOGxydHdhb2lpNw%3D%3D#" className="instagram" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-instagram" />
          </a>
          <a href="https://www.youtube.com/@MALLABHUMPRAYAS" className="youtube" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-youtube" />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
